import Mutations from '../../odata/mutations';

export default { ...new Mutations('jobListingCandidateTask'), ...new Mutations('jobListingCandidateTasks') };
